<template>
    <div class="w-h-100" style="background:#fff;">
        <div style="padding:20px;height:90%;">
            <div class="flex just-between">
                <div style="margin-bottom:20px;">
                    <el-button type="primary" plain icon="el-icon-plus" size="small" @click="handleClick">增加</el-button>
                </div>
                <el-form :inline="true" :model="catalogQuery" class="demo-form-inline">
                    <el-form-item label="栏目名称">
                        <el-select v-model="catalogQuery.parentId" size="small" clearable allow-create placeholder="请选择上级栏目名称">
                            <el-option
                            v-for="item in selectList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="catalogQuery.status" placeholder="启用状态" size="small" clearable>
                            <el-option :value="1" label="启用"></el-option>
                            <el-option :value="0" label="停用"></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="首页展示">
                        <el-select v-model="catalogQuery.homeDisplay" placeholder="首页展示" size="small" clearable>
                            <el-option value="1" label="是"></el-option>
                            <el-option value="0" label="否"></el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="getLmwhList">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <el-table
                :data='dataList'
                :header-cell-style="{textAlign: 'center',background: '#409EFF',color: '#fff'}"
                :cell-style="{textAlign: 'center'}"
                style="width:100%;border:none;"
            >
                <el-table-column type='index' label='序号' width="60"></el-table-column>
                <el-table-column prop="name" label="栏目名称"></el-table-column>
                <el-table-column prop="parent.name" label="上级栏目"></el-table-column>
                <el-table-column prop="hyperlink" width="100" label="是否超链接">
                    <template slot-scope="scope">
                        <span>{{scope.row.hyperlink ? "是" : "否"}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="linkUrl" label="超链接地址"></el-table-column>
                <el-table-column prop="sort" width="80" label="排序"></el-table-column>
                <el-table-column prop="status" width="100" label="状态">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.status"
                        :inactive-value="0"
                        :active-value="1"
                        @change="changeStatus(scope.row)"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="homeDisplay" width="100" label="首页展示">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.homeDisplay"
                        v-if="!scope.row.parent && !scope.row.hyperlink"
                        :inactive-value="0"
                        :active-value="1"
                        @change="changeHomeDisplay(scope.row)"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="icon" width="100" label="图标">
                    <template slot-scope="scope">
                        <span class="iconfont" :class="scope.row.icon" style="font-size:26px;"></span>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="userId" width="120" label="创建人"></el-table-column> -->
                <el-table-column prop="time" width="120" label="创建时间"></el-table-column>
                <el-table-column label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button size="small" icon="el-icon-edit" style="margin-right:10px;" @click="handleEdit(scope.row)">修改</el-button>
                        <el-button size="small" icon="el-icon-delete" @click="handleDelete(scope.row)" v-if="scope.row.id !== 'deptDuty'">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                style="margin:20px 0;"
                layout='->, prev,pager,next,total,sizes,jumper'
                @size-change='changeSize'
                @current-change='changeCurrent'
                :page-sizes="['10','20','30','40','50']"
                :page-size="catalogQuery.pageSize"
                :current-page='catalogQuery.pageNum'
                :total='total'
            >
            </el-pagination>
        </div>
        <el-dialog
            style="text-align:left;color:#fff;"
            :title="addFlag ? '新增' : '修改'"
            @close='addCancle'
            :close-on-click-modal="false"
            :visible.sync = "addDialog"
            width="600px">
            <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="120px">
                <el-form-item label="栏目名称" prop="name">
                    <el-input placeholder="请输入栏目名称" v-model="formData.name" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="是否超链接" prop="hyperlink">
                    <el-radio v-model="formData.hyperlink" :label="true" @change="changeHyperLink">是</el-radio>
                    <el-radio v-model="formData.hyperlink" :label="false" @change="changeHyperLink">否</el-radio>
                </el-form-item>
                <el-form-item label="超链接地址" prop="linkUrl" v-if="formData.hyperlink">
                    <el-input placeholder="请输入超链接地址" v-model="formData.linkUrl" style="width: 300px"
                    @blur="valideLinkUrl"></el-input>
                </el-form-item>
                <div v-if="!formData.hyperlink">
                    <el-form-item label="上级栏目" v-if="addFlag" >
                        <el-select v-model="formData.parentId" placeholder="请选择上级栏目" clearable style="width: 300px">
                            <el-option v-for="item in selectList" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="上级栏目" v-if="addFlag === false && formData.parent" >
                        {{formData.parent.name}}
                    </el-form-item>
                </div>
                <el-form-item label="首页展示" prop="homeDisplay" v-if="!formData.parentId && !formData.hyperlink">
                    <el-radio v-model="formData.homeDisplay" :label="1">展示</el-radio>
                    <el-radio v-model="formData.homeDisplay" :label="0">不展示</el-radio>
                </el-form-item>
                <el-form-item label="展示类型" prop="showType" v-if="!formData.parentId && !formData.hyperlink">
                    <el-radio v-model="formData.showType" :label="0">单列</el-radio>
                    <el-radio v-model="formData.showType" :label="1">双列</el-radio>
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                    <el-input placeholder="请输入排序" v-model="formData.sort" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="启用状态" prop="status">
                    <el-radio @change="changeSelect" v-model="formData.status" :label="1">启用</el-radio>
                    <el-radio @change="changeSelect" v-model="formData.status" :label="0">停用</el-radio>
                </el-form-item>
                <el-form-item label="栏目图标" prop="icon" class="icon-class">
                    <el-select v-model="formData.icon" style="width: 300px" clearable allow-create placeholder="请选择栏目图标">
                        <el-option
                        v-for="item in iconList.glyphs"
                        :key="item.id"
                        :label="item.name"
                        :value="item.font_class">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div style="text-align:right;">
                <el-button size="small" @click="addCancle" class="queding-btn">取消</el-button>
                <el-button size="small" type="primary" @click="addConfirm" class="queding-btn">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
/* eslint-disable no-debugger */
export default {
    data() {
        return {
            selectList: [],
            myTableColumn: [
                {
                    prop: 'name',
                    label: '栏目名称',
                    select: false
                },
                {
                    prop: 'parentId',
                    label: '上级栏目',
                    select: false
                },
                {
                    prop: 'sort',
                    label: '排序',
                    select: false
                },
                {
                    prop: 'status',
                    label: '启用状态',
                    select: false
                },
                {
                    prop: 'userId',
                    label: '创建人',
                    select: false
                },
                {
                    prop: 'createTime',
                    label: '创建时间',
                    select: false
                }
            ],
            iconList: require('../assets/iconfont/iconfont.json'),
            addDialog: false,
            addFlag: true,
            total: 0,
            imageUrl: '',
            options: [
                {
                    label: '123',
                    value: 1
                }
            ],
            catalogQuery: {
                parentId: '',
                status: null,
                homeDisplay: null,
                pageSize: 10,
                pageNum: 1
            },
            dataList: [],
            formData: {
                name: '',
                parentId: '',
                sort: '',
                status: 1,
                homeDisplay: 1,
                showType: 0,
                icon: '',
                hyperlink: false,
                linkUrl: ""
            },
            rules: {
                name: [{ required: true, message: '请输入栏目名称', trigger: 'blur' },
                        { max: 8, message: '栏目名称最多8个汉字', trigger: 'blur' }],
                sort: [{ required: true, message: '请输入排序', trigger: 'blur' },
                { pattern: /^[0-9]\d*$/, message: '排序码需为正整数', trigger: 'blur' }],
                status: [{ required: true, message: '请选择状态', trigger: 'change' }],
                icon: [{ required: true, message: '请选择图标', trigger: 'blur' }],
                linkUrl: [{ required: true, message: '请输入超链接地址', trigger: 'blur' },
                { pattern: /^(?:(http|https|ftp|smtp):\/\/)?(((?:[a-z0-9-]+\.)+[a-z]{2,20})|([0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}))(:(6553[0-5]|655[0-2]\d|65[0-4]\d{2}|6[0-4]\d{3}|[1-5]\d{4}|[1-9]\d{0,3}))?(?:(?:\/(?:[\w#!:.?+=&%@!\/-])*)+\/?)?$/,
                 message: '超链接地址格式错误！示例：http://www.zfsoft.com:8080/zftal-hrm', trigger: 'blur'}]
            }
        }
    },
    methods: {
        valideLinkUrl () {
            this.$refs.ruleForm.validateField("linkUrl")
        },
        changeSelect () {
            this.$forceUpdate()
        },
        changeHyperLink () {
            this.$refs.ruleForm.clearValidate()
        },
        handleClick () {
            this.formData = {
                name: '',
                parentId: '',
                sort: '',
                status: 1,
                homeDisplay: 1,
                showType: 0,
                icon: '',
                hyperlink: false,
                linkUrl: ""
            }
            this.addFlag = true
            this.addDialog = true
        },
        changeSize (value) {
            // this.pageData.pageSize = value
            this.catalogQuery.pageSize = value
            this.getLmwhList()
        },
        changeCurrent (value) {
            // this.pageData.pageNum = value
            this.catalogQuery.pageNum = value
            this.getLmwhList()
        },
        handleEdit (data) {
            this.addFlag = false
            this.$refs.ruleForm?.resetFields();
            this.$api.website.getCategoryInfo(data.id).then(res => {
                if (res.code === 200) {
                    this.formData = res.data
                    if (this.formData.icon.length > 0) {
                        this.formData.icon = this.formData.icon.substr(4)
                    }
                    if (this.formData.parent) {
                        this.formData.parentId = this.formData.parent.id
                    }
                    this.addDialog = true
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        handleDelete (data) {
            this.$confirm('确定要删除栏目【' + data.name + '】吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.website.removeCategory(data).then(res => {
                    if (res.code === 200) {
                        this.$message.success('删除成功')
                        this.getLmwhList()
                    } else {
                        this.$message.error(res.message)
                    }
                })
            }).catch(() => {
                this.$message.info('取消删除')
            })
        },
        changeStatus (data) {
            this.$api.website.modifyCategory(data).then(res => {
                if (res.code === 200) {
                    this.$message.success('状态变更成功')
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        changeHomeDisplay (data) {
            this.$api.website.modifyCategory(data).then(res => {
                if (res.code === 200) {
                    this.$message.success('首页展示变更成功')
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        getTime (item) {
            let str = ''
            if (item.createTime) {
               const array = item.createTime.split('T')
               str = array[0]
            }
            return str
        },
        getLmwhList () {
            this.$api.website.getCategoryPageList(this.catalogQuery).then(res => {
                if (res.code === 200) {
                    res.data.content.forEach(item => {
                        const time = this.getTime(item)
                        item.time = time
                    })
                    this.dataList = res.data.content
                    this.total = res.data.totalElements
                }
            })
        },
        getSelectList () {
            const param = {
                pageSize: 20,
                pageNum: 1,
                root: true
            }
            this.$api.website.getCategoryPageList(param).then(res => {
                if (res.code === 200) {
                    this.selectList = res.data.content
                }
            })
        },
        addCancle () {
            this.addDialog = false
            this.formData = {
                name: '',
                parentId: '',
                sort: '',
                status: 1,
                homeDisplay: 1,
                showType: 0,
                icon: '',
                hyperlink: false,
                linkUrl: ""
            }
        },
        addConfirm () {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    if (this.formData.parentId) {
                        this.formData.parent = { id: this.formData.parentId }
                    }
                    if (this.formData.icon) {
                        this.formData.icon = 'icon' + this.formData.icon
                    }
                    if (this.addFlag) {
                        this.$api.website.addCategory(this.formData).then(res => {
                            if (res.code === 200) {
                                this.$message.success('新增成功')
                                this.getLmwhList()
                                this.getSelectList()
                                this.addDialog = false
                            } else {
                                this.$message.error(res.message)
                            }
                        })
                    } else {
                        this.$api.website.modifyCategory(this.formData).then(res => {
                            if (res.code === 200) {
                                this.$message.success('修改成功')
                                this.getLmwhList()
                                this.getSelectList()
                                this.addDialog = false
                            } else {
                                this.$message.error(res.message)
                            }
                        })
                    }
                }
            })
        },
        handleAvatarSuccess () {},
        beforeAvatarUpload () {}
    },
    created() {
        this.getLmwhList()
        this.getSelectList()
    },
}
</script>

<style scoped lang='less'>
/deep/ .icon-class .el-form-item__content {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
/deep/ .el-button+.el-button, .el-checkbox.is-bordered+.el-checkbox.is-bordered{
  margin-left: 0;
}
/deep/ .el-checkbox.is-bordered{
  margin-bottom: 10px;
}
/deep/ .el-checkbox__input{
  vertical-align: inherit;
}
</style>
